import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import FileButton from './FileButton';
import uploadFile from '../utils/uploadFile';
/**
 * Creates (or edits) one toxicity category for a société - attrs.society
 * (required on create) + attrs.toxicity (existing model, switches to edit
 * mode). SVG upload is the same fof/upload flow as
 * ExhibitionFindingEditModal's own photo upload, storing into a single
 * svgUrl instead of that sibling feature's photos[] array (one toxicity
 * icon, not several) - no svgType column either, since a photo's own
 * `type` is stored but never actually read anywhere, so it's skipped here
 * as a real simplification.
 */
export default class ToxicityEditModal extends Modal {
  name = '';
  svgUrl = null;
  svgUploading = false;
  loading = false;
  errorMessage = null;
  oninit(vnode) {
    super.oninit(vnode);
    const toxicity = this.attrs.toxicity;
    this.name = toxicity && toxicity.name() || '';
    this.svgUrl = toxicity && toxicity.svgUrl() || null;
    this.svgUploading = false;
    this.loading = false;
    this.errorMessage = null;
  }
  className() {
    return 'Modal--small ChampisToxicityEditModal';
  }
  title() {
    const t = key => app.translator.trans(`champis-exhibitions.forum.toxicity_modal.${key}`);
    return this.attrs.toxicity ? t('edit_title') : t('create_title');
  }
  content() {
    const t = key => app.translator.trans(`champis-exhibitions.forum.toxicity_modal.${key}`);
    return m("div", {
      className: "Modal-body"
    }, this.errorMessage && m("div", {
      className: "ChampisToxicityEditModal-error"
    }, this.errorMessage), m("div", {
      className: "ChampisToxicityEditModal-field"
    }, m("label", null, t('name_label'), m("input", {
      className: "FormControl",
      type: "text",
      value: this.name,
      oninput: e => {
        this.name = e.target.value;
      }
    }))), m("div", {
      className: "ChampisToxicityEditModal-field"
    }, m("label", null, t('svg_label')), this.svgUrl ? m("div", {
      className: "ChampisToxicityEditModal-svg"
    }, m("img", {
      className: "ChampisToxicityEditModal-svgThumb",
      src: this.svgUrl,
      alt: ""
    }), m(Button, {
      className: "Button Button--link",
      onclick: () => this.removeSvg()
    }, t('svg_remove'))) : m("div", {
      className: "ChampisToxicityEditModal-svgUpload"
    }, m(FileButton, {
      accept: "image/svg+xml",
      icon: "fas fa-upload",
      disabled: this.svgUploading,
      onfile: file => this.uploadSvg(file)
    }, t('svg_choose_button')), this.svgUploading && m("span", {
      className: "ChampisToxicityEditModal-uploading"
    }, t('svg_uploading')))), m("div", {
      className: "ChampisToxicityEditModal-footer"
    }, m(Button, {
      className: "Button Button--primary",
      onclick: () => this.submit(),
      loading: this.loading,
      disabled: !this.canSubmit()
    }, t('save_button'))));
  }
  uploadSvg(file) {
    if (!file) return;
    this.svgUploading = true;
    m.redraw();
    uploadFile(file).then(uploaded => {
      this.svgUploading = false;
      if (uploaded) {
        this.svgUrl = uploaded.attributes.url;
      }
      m.redraw();
    }).catch(error => {
      this.svgUploading = false;
      this.errorMessage = error.response && error.response.errors && error.response.errors[0] && error.response.errors[0].detail || app.translator.trans('champis-exhibitions.forum.toxicity_modal.error');
      m.redraw();
    });
  }
  removeSvg() {
    this.svgUrl = null;
  }

  // Both name and a successful SVG upload are treated as required here,
  // enforced only at this JS level (the API field itself stays nullable,
  // same as photoUrl on findings) - the user's phrasing ("chaque toxicité
  // contient un nom et une image svg") implies both are inherent parts of
  // a toxicity record, unlike a finding's explicitly-optional photo.
  canSubmit() {
    if (this.loading || this.svgUploading) return false;
    return !!this.name.trim() && !!this.svgUrl;
  }
  submit() {
    this.loading = true;
    this.errorMessage = null;
    m.redraw();
    const attributes = {
      name: this.name.trim(),
      svgUrl: this.svgUrl
    };
    const toxicity = this.attrs.toxicity || app.store.createRecord('champis-exhibitions-toxicities');
    const relationships = this.attrs.toxicity ? undefined : {
      society: this.attrs.society
    };
    toxicity.save(relationships ? {
      ...attributes,
      relationships
    } : attributes).then(() => {
      this.loading = false;
      this.hide();
      if (this.attrs.onsaved) this.attrs.onsaved(toxicity);
    }).catch(error => {
      this.loading = false;
      this.errorMessage = error && error.message || app.translator.trans('champis-exhibitions.forum.toxicity_modal.error');
      m.redraw();
    });
  }
}
flarum.reg.add('champis-exhibitions', 'forum/components/ToxicityEditModal', ToxicityEditModal);